import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';

const getAppartements = (t) => [
  {
    id: 1,
    title: t('apts.quartz.title'),
    description: t('apts.quartz.desc'),
    images: [
      '/photo-site/quartz/072CCA5C-15A2-45AF-8354-CC363343543F.JPG',
      '/photo-site/quartz/0BB32FC4-9833-4A9B-8202-85A648FCF0FD.JPG',
      '/photo-site/quartz/139FF3F7-FA2A-46E3-A7D3-FF2008007032.JPG',
      '/photo-site/quartz/50885530-774A-4363-B733-170E90B93ACB.JPG',
      '/photo-site/quartz/5A23341E-9215-4B4B-B491-942BF71DF9BA.JPG',
      '/photo-site/quartz/909CF4A0-F3EC-4A43-90D1-3B2B023639A2.JPG',
      '/photo-site/quartz/953CF745-30B6-403E-BD52-4DC5AB67065A.JPG',
      '/photo-site/quartz/9DF68265-7F76-4716-99BC-8D48504BABC4.JPG',
      '/photo-site/quartz/IMG_7074.jpeg',
      '/photo-site/quartz/IMG_7237.jpeg',
      '/photo-site/quartz/IMG_7238.jpeg',
    ],
    features: [t('apts.quartz.f1'), t('apts.quartz.f2'), t('apts.quartz.f3')],
    price: t('apts.quartz.price'),
    path: "/appartements/appartement-2-personnes-quartz"
  },
  {
    id: 2,
    title: t('apts.siderite.title'),
    description: t('apts.siderite.desc'),
    images: [
      '/photo-site/siderite/04DBDCE6-B7FD-4EC7-B377-DC11C8851257.JPG',
      '/photo-site/siderite/3B6C94D3-AA1B-4CD2-8B55-AD8E73DB86C0.JPG',
      '/photo-site/siderite/662BC4D9-7F85-40C0-BAE3-BDA75094E5BE.JPG',
      '/photo-site/siderite/AC150037-BC3D-4C11-B15A-3B3F4D220077.JPG',
      '/photo-site/siderite/IMG_7064.jpeg',
      '/photo-site/siderite/IMG_7260.jpeg',
      '/photo-site/siderite/IMG_7261.jpeg',
      '/photo-site/siderite/IMG_7262.jpeg',
      '/photo-site/siderite/IMG_7263.jpeg',
      '/photo-site/siderite/IMG_7266.jpeg',
      '/photo-site/siderite/IMG_7267.jpeg',
      '/photo-site/siderite/IMG_7268.jpeg',
      '/photo-site/siderite/IMG_7269.jpeg',
      '/photo-site/siderite/IMG_7270.jpeg',
    ],
    features: [t('apts.siderite.f1'), t('apts.siderite.f2'), t('apts.siderite.f3')],
    price: t('apts.siderite.price'),
    path: "/appartements/appartement-4-personnes-siderite"
  },
  {
    id: 3,
    title: t('apts.epidote.title'),
    description: t('apts.epidote.desc'),
    images: [
      '/photo-site/epidote/9DB5A578-7FBF-4B5C-9815-D4EB42BD7CB5.JPG',
      '/photo-site/epidote/B3C59C9C-7865-41C8-A77A-6296686E6C13.JPG',
      '/photo-site/epidote/CBDA58AA-E919-4EB7-B226-4E650B8C53A3.JPG',
      '/photo-site/epidote/EA2CE42F-BC9B-4964-BE78-C6EB78548F8F.JPG',
      '/photo-site/epidote/F4CB029E-D741-46C1-B369-B7EB07E8C188.JPG',
      '/photo-site/epidote/IMG_6862.jpeg',
      '/photo-site/epidote/IMG_7045.jpeg',
      '/photo-site/epidote/IMG_7071.jpeg',
      '/photo-site/epidote/IMG_7077.jpeg',
      '/photo-site/epidote/IMG_7078.jpeg',
      '/photo-site/epidote/IMG_7088.jpeg',
      '/photo-site/epidote/IMG_7240.jpeg',
      '/photo-site/epidote/IMG_7244.jpeg',
      '/photo-site/epidote/IMG_7245.jpeg',
      '/photo-site/epidote/IMG_7246.jpeg',
      '/photo-site/epidote/IMG_7251.jpeg',
      '/photo-site/epidote/IMG_7253.jpeg',
      '/photo-site/epidote/IMG_7254.jpeg',
      '/photo-site/epidote/IMG_7255.jpeg',
    ],
    features: [t('apts.epidote.f1'), t('apts.epidote.f2'), t('apts.epidote.f3')],
    price: t('apts.epidote.price'),
    path: "/appartements/appartement-6-personnes-epidote"
  }
];

const CardSlider = React.memo(({ images, title }) => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [paused, images.length]);

  return (
    <div
      className="relative h-60 overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`${title} - vue ${i + 1}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700
            ${i === current ? 'opacity-100' : 'opacity-0'}`}
          loading={i === 0 ? 'eager' : 'lazy'}
        />
      ))}

      <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1 z-10">
        {images.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all duration-300
              ${i === current ? 'w-4 bg-white' : 'w-1.5 bg-white/50'}`}
            aria-label={`Photo ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
});

const AppartementCard = React.memo(({ apt, isSelected, onToggle, onNavigate, t }) => (
  <div className="bg-base-200 rounded-2xl shadow-lg overflow-hidden group transition-all duration-700 hover:shadow-2xl transform hover:-translate-y-2">
    <CardSlider images={apt.images} title={apt.title} />

    <div className="p-6">
      <div className="flex justify-between items-start mb-3">
        <h2 className="text-2xl font-bold text-base-content group-hover:text-primary transition-colors">
          {apt.title}
        </h2>
        <div className="bg-primary text-primary-content px-3 py-1 rounded-full text-sm whitespace-nowrap">
          {apt.price}
        </div>
      </div>

      <p className="text-base-content/80 mb-4">{apt.description}</p>

      <div className="space-y-4">
        <button
          onClick={() => onToggle(apt.id)}
          className="w-full btn btn-ghost justify-between"
          aria-expanded={isSelected}
        >
          <span>{t('apts.features')}</span>
          <span
            className="transition-transform duration-300"
            style={{ transform: isSelected ? 'rotate(180deg)' : 'rotate(0deg)' }}
          >
            ↓
          </span>
        </button>

        {isSelected && (
          <div className="pl-4 border-l-2 border-primary space-y-2">
            {apt.features.map((feature, idx) => (
              <div key={idx} className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-6 pt-4 border-t border-base-300">
        <button
          onClick={() => onNavigate(apt.path)}
          className="btn btn-primary w-full"
        >
          {t('apts.viewApt')}
        </button>
      </div>
    </div>
  </div>
));

const Appartements = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [selectedApt, setSelectedApt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const pageRef = useRef(null);

  const appartements = getAppartements(t);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Appartements La Marmotte Joyeuse",
    "description": "Trois appartements rénovés au cœur de La Grave, face à la Meije.",
    "itemListElement": appartements.map((apt, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "LodgingReservation",
        "name": apt.title,
        "description": apt.description,
        "image": `https://marmottejoyeuse.fr${apt.images[0]}`,
        "url": `https://marmottejoyeuse.fr${apt.path}`,
        "priceRange": apt.price,
        "amenityFeature": apt.features
      }
    }))
  };

  useEffect(() => {
    if (pageRef.current) {
      const timer = setTimeout(() => setIsVisible(true), 300);
      return () => clearTimeout(timer);
    }
  }, []);

  const toggleAptDetails = useCallback((id) => {
    setSelectedApt(prev => prev === id ? null : id);
  }, []);

  const handleNavigate = useCallback((path) => {
    navigate(path);
  }, [navigate]);

  return (
    <>
      <SEO
        title={t('seo.apts.title')}
        description={t('seo.apts.description')}
        keywords="appartement la grave, location montagne, hébergement alpes, appartement quartz, appartement sidérite, appartement épidote, location la grave"
        url="/appartements"
        structuredData={structuredData}
      />
      <div ref={pageRef} className="container mx-auto px-4 pt-28 pb-16 min-h-screen">

        <div className={`mb-16 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-5xl font-extrabold mb-4 text-primary">{t('apts.title')}</h1>
          <p className="text-xl max-w-3xl mx-auto text-base-content/80 mb-8">
            {t('apts.subtitle')}
          </p>
          <div className="h-1 w-32 bg-primary mx-auto" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-16">
          {appartements.map((apt) => (
            <AppartementCard
              key={apt.id}
              apt={apt}
              isSelected={selectedApt === apt.id}
              onToggle={toggleAptDetails}
              onNavigate={handleNavigate}
              t={t}
            />
          ))}
        </div>

      </div>
    </>
  );
};

export default React.memo(Appartements);
